module.exports = __webpack_public_path__ + "static/media/risk.075e19d1.png";